import React from 'react';
import { Alert, Button, Space, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useExpiringAssets } from '../hooks/api/assets/hooks';
import { useNavigate } from 'react-router-dom';

export const ExpiringAssetsAlert: React.FC = () => {
  const navigate = useNavigate();
  const { data } = useExpiringAssets({ days: 30, page: 1, limit: 5 });
  const total = data?.extra?.total ?? 0;
  const items = data?.data ?? [];

  if (total === 0) return null;

  const description = (
    <Space direction="vertical" size={2}>
      {items.slice(0, 3).map((a: any) => (
        <Typography.Text key={a.id} type="secondary">
          &bull;{' '}{a.name} &mdash;{' '}
          {a.warranty_status === 'expired' || a.warranty_status === 'expiring_soon'
            ? `warranty ${a.days_until_warranty_expiry !== null && a.days_until_warranty_expiry < 0 ? 'expired' : `expires in ${a.days_until_warranty_expiry}d`}`
            : `insurance ${a.days_until_insurance_expiry !== null && a.days_until_insurance_expiry < 0 ? 'expired' : `expires in ${a.days_until_insurance_expiry}d`}`}
        </Typography.Text>
      ))}
      {total > 3 && (
        <Button type="link" size="small" onClick={() => navigate('/assets')} style={{ padding: 0 }}>
          View all {total} expiring assets
        </Button>
      )}
    </Space>
  );

  return (
    <Alert
      type="warning"
      showIcon
      icon={<WarningOutlined />}
      message={`${total} asset${total !== 1 ? 's' : ''} with expiring warranty or insurance`}
      description={description}
      closable
      style={{ marginBottom: 16 }}
    />
  );
};
